import { render, staticRenderFns } from "./PendingTitles.vue?vue&type=template&id=6d029c1d&scoped=true&"
import script from "./PendingTitles.vue?vue&type=script&lang=js&"
export * from "./PendingTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d029c1d",
  null
  
)

export default component.exports